import { z } from 'zod';
const text = z.string().max(10000);
// Legacy measures describe planned improvements, never current controls or confirmed completion.
const score = z.object({ possibility: z.number().int().min(1).max(5).nullable(), severity: z.number().int().min(1).max(4).nullable() }).strict();
export const riskAdHocOriginalDraftSchema = z.object({
    company: text, workName: text, workDate: z.string().max(100), evaluators: z.array(text).max(100),
    items: z.array(z.object({
        workStep: text, hazards: z.array(text).max(100), measures: z.array(text).max(100),
        manager: text, improvePeriod: text, beforeScore: score, afterScore: score,
    }).strict()).min(1).max(80),
}).strict();
export const riskAdHocOriginalSnapshotSchema = z.object({
    archiveId: z.string().regex(/^support-[a-f0-9]{48}$/u), sourceHash: z.string().regex(/^[a-f0-9]{64}$/u),
    version: z.number().int().nonnegative(), draft: riskAdHocOriginalDraftSchema,
    canEdit: z.boolean(), updatedAt: z.string().datetime().nullable(),
}).strict();
